import React, { useRef } from "react";
import AccessibleDialog from "../UI/Modals/AccessibleDialog/AccessibleDialog";
import styles from "./EndCallConfirmModal.module.scss";

interface EndCallConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// Overlay must sit above FloatingVideoPanel's wrapper (z-index 9998).
const OVERLAY_Z_INDEX = 10000;

const TITLE_ID = "end-call-confirm-title";

const EndCallConfirmModal: React.FC<EndCallConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  // Focus "Otkaži" on open so ENTER defaults to cancel, not end-call.
  const cancelButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <AccessibleDialog
      isOpen={isOpen}
      onRequestClose={onCancel}
      titleId={TITLE_ID}
      initialFocusRef={cancelButtonRef}
      overlayZIndex={OVERLAY_Z_INDEX}
      showCloseButton={false}
      maxWidth={400}
    >
      <div className={styles.container}>
        <h3 id={TITLE_ID} className={styles.title}>
          Prekini konsultaciju?
        </h3>
        <p className={styles.description}>
          Konsultacija će biti završena i ne može se nastaviti.
        </p>
        <div className={styles.actions}>
          <button
            ref={cancelButtonRef}
            type="button"
            className={styles.cancelButton}
            onClick={onCancel}
          >
            Otkaži
          </button>
          <button
            type="button"
            className={styles.confirmButton}
            onClick={onConfirm}
          >
            Prekini
          </button>
        </div>
      </div>
    </AccessibleDialog>
  );
};

export default EndCallConfirmModal;
